import type { DateRange } from '@/entities/query';

export enum PresetName {
  TODAY = 'today',
  YESTERDAY = 'yesterday',
  LAST7 = 'last7',
  LAST14 = 'last14',
  LAST30 = 'last30',
  LAST60 = 'last60',
  LAST90 = 'last90',
  THIS_MONTH = 'thisMonth',
  THIS_YEAR = 'thisYear',
}

export interface Preset {
  name: PresetName;
  label: string;
}

// Define presets
export const PRESETS: Preset[] = [
  // 현재로선 오늘 데이터가 없어서 주석 처리해둡니다. 나중에 필요해지면 다시 주석을 제거해주세요.
  // { name: PresetName.TODAY, label: 'Today' },
  { name: PresetName.YESTERDAY, label: 'Yesterday' },
  { name: PresetName.LAST7, label: 'Last 7 days' },
  { name: PresetName.LAST14, label: 'Last 14 days' },
  { name: PresetName.LAST30, label: 'Last 30 days' },
  { name: PresetName.LAST60, label: 'Last 60 days' },
  { name: PresetName.LAST90, label: 'Last 90 days' },
  { name: PresetName.THIS_MONTH, label: 'This month' },
  { name: PresetName.THIS_YEAR, label: 'This year' },
];

export const getPresetDateRange = (presetName: PresetName): DateRange => {
  const preset = PRESETS.find(({ name }) => name === presetName);
  if (!preset) {
    throw new Error(`Unknown date range preset: ${presetName}`);
  }

  const from = new Date();
  const to = new Date();

  switch (preset.name) {
    case PresetName.TODAY:
      from.setHours(0, 0, 0, 0);
      to.setHours(23, 59, 59, 999);
      break;
    case PresetName.YESTERDAY:
      from.setDate(from.getDate() - 1);
      from.setHours(0, 0, 0, 0);
      to.setDate(to.getDate() - 1);
      to.setHours(23, 59, 59, 999);
      break;
    case PresetName.LAST7:
      from.setDate(from.getDate() - 6);
      from.setHours(0, 0, 0, 0);
      to.setHours(23, 59, 59, 999);
      break;
    case PresetName.LAST14:
      from.setDate(from.getDate() - 13);
      from.setHours(0, 0, 0, 0);
      to.setHours(23, 59, 59, 999);
      break;
    case PresetName.LAST30:
      from.setDate(from.getDate() - 29);
      from.setHours(0, 0, 0, 0);
      to.setHours(23, 59, 59, 999);
      break;
    case PresetName.LAST60:
      from.setDate(from.getDate() - 59);
      from.setHours(0, 0, 0, 0);
      to.setHours(23, 59, 59, 999);
      break;
    case PresetName.LAST90:
      from.setDate(from.getDate() - 89);
      from.setHours(0, 0, 0, 0);
      to.setHours(23, 59, 59, 999);
      break;
    case PresetName.THIS_MONTH:
      from.setDate(1);
      from.setHours(0, 0, 0, 0);
      to.setHours(23, 59, 59, 999);
      break;
    case PresetName.THIS_YEAR:
      from.setMonth(0);
      from.setDate(1);
      from.setHours(0, 0, 0, 0);
      to.setHours(23, 59, 59, 999);
      break;
  }

  return { startDate: from.toJSON(), endDate: to.toJSON() };
};
